<template>
    <div>
        <button
            class="btn btn-md is-ghost is-danger"
            :disabled="address.is_signed"
            :title="address.is_signed ? 'Adressen har en signerad beställning, om den ska raderas behöver ordern först annulleras' : ''"
            @click="$modal.show('delete-address')"
        >
            Radera
        </button>
        <adaptive-form-modal
            name="delete-address"
            primary-button-text="Radera"
            primary-button-class="is-danger"
            title="Radera adress"
            :redirect-to="route('admin.sales-projects.addresses.index', project)"
            method="delete"
            :action="route('api.sales-projects.addresses.destroy', [project, address.id])"
        >
            <p>Vill du verkligen radera adressen?</p>
        </adaptive-form-modal>
    </div>
</template>

<script>
    export default {
        props: {
            address: {
                type: Object,
                required: true,
            },
            project: {
                type: Object,
                required: true,
            },
        },
    };
</script>
